var exports = {
  "Lg": "GuildSidebarSkeleton.module__navigation___SnFpTl",
  "X9": "GuildSidebarSkeleton.module__detachedBanner___SnFpTl",
  "GG": "GuildSidebarSkeleton.module__topSpacer___SnFpTl",
  "dl": "GuildSidebarSkeleton.module__membersSection___SnFpTl",
  "ne": "GuildSidebarSkeleton.module__membersSeparator___SnFpTl",
  "vd": "GuildSidebarSkeleton.module__bottomDropZone___SnFpTl",
  "TN": "GuildSidebarSkeleton.module__groups___SnFpTl",
  "Os": "GuildSidebarSkeleton.module__group___SnFpTl",
  "nM": "GuildSidebarSkeleton.module__row___SnFpTl",
  "bQ": "GuildSidebarSkeleton.module__rowCategory___SnFpTl",
  "me": "GuildSidebarSkeleton.module__categoryCaret___SnFpTl",
  "et": "GuildSidebarSkeleton.module__rowChannel___SnFpTl",
  "Ec": "GuildSidebarSkeleton.module__rowMembers___SnFpTl",
  "p": "GuildSidebarSkeleton.module__channelIcon___SnFpTl",
  "US": "GuildSidebarSkeleton.module__bottomSpacer___SnFpTl",
};

module.exports = exports;
